import * as React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Stack,
  MenuItem,
} from "@mui/material";

const LOCATIONS = [
  "FortMyers",
  "FortPierce",
  "Immokalee",
  "Lehigh",
  "Naples",
  "LakeWorth",
  "PortSaintLucie",
];

export default function ScheduleDialog({ open, onClose, onConfirm, item }) {
  const [date, setDate] = React.useState("");
  const [location, setLocation] = React.useState("");

  React.useEffect(() => {
    if (!open) {
      setDate("");
      setLocation("");
    }
  }, [open]);

  const handleConfirm = () => {
    onConfirm?.({ date, location, item });
    onClose?.();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Schedule – {item?.careGapName}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField
            label="Date"
            type="date"
            InputLabelProps={{ shrink: true }}
            value={date}
            onChange={(e) => setDate(e.target.value)}
            fullWidth
          />
          <TextField
            select
            label="Location"
            value={location}
            onChange={(e) => setLocation(e.target.value)}
            fullWidth
          >
            {LOCATIONS.map((loc) => (
              <MenuItem key={loc} value={loc}>
                {loc}
              </MenuItem>
            ))}
          </TextField>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleConfirm}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
